import { ref, computed, toValue } from 'vue'
import useAuthStore from '@/stores/auth'
import useToasterStore from '@/stores/toaster'
import DepotService from '@/services/depot'
import type { Vehicle } from '@/data/schema/vehicle'

export default function useVehicles(contract: any, depot: any) {
	const api = new DepotService()
	const auth = useAuthStore()
	const toaster = useToasterStore()

	// Deliveries
	const delType = ref()
	const delTypeOptions = [
		{
			label: 'Own Transport',
			value: '0'
		},
		{
			label: 'External Haulier',
			value: '1'
		},
		{
			label: 'Customer Own',
			value: '2'
		}
	]

	// Vehicles
	const vehicle = ref()
	const vehicleOptions = ref([])
	const vehiclesLoading = ref(false)
	const selectedVehicle = computed(() => {
		if (!vehicle.value) {
			return null
		}

		const vehicleObj = vehicleOptions.value.find((obj: Vehicle) => obj.id == vehicle.value)

		if (vehicleObj) {
			return vehicleObj as Vehicle
		}

		return null
	})

	/**
	 * Get Load Vehicle data
	 */
	async function getVehicles() {
		vehiclesLoading.value = true
		let depots = []

		if (!toValue(depot!)) {
			depots = auth.user!.assigned_depots
		} else {
			depots = [toValue(depot!)]
		}

		if (contract && toValue(contract)?.hire_depot) {
			api.getLoadVehicles(depots, delType.value)
				.then((res) => {
					vehicleOptions.value = res.data.data
					vehiclesLoading.value = false
				})
				.catch((error: any) => {
					toaster.error({ text: 'Error occurred retrieving load vehicles' })
					console.error(error)
					vehiclesLoading.value = false
				})
		} else {
			toaster.warning({ text: 'Invalid contract depot value' })
		}
	}

	/**
	 * Reset values
	 */
	function resetLoad() {
		delType.value = null
		vehicle.value = null
		vehicleOptions.value = []
	}

	return {
		delType,
		delTypeOptions,
		vehicle,
		vehicleOptions,
		vehiclesLoading,
		selectedVehicle,
		getVehicles,
		resetLoad
	}
}
